import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class ValidateAiCookiesRequest extends BaseServiceRequest {
  constructor() {
    super();
    super.addRequestUri("validateUserCookie");
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  // getMessageName() {
  //   return "AiInsightsCategoriesResponseData";
  // }
}

export default ValidateAiCookiesRequest;
